export function hexToBase64(value: string): string {
  const matches = value.match(/.{2}/g);
  if (!matches) {
    throw new Error("Invalid input string");
  }
  return btoa(String.fromCharCode(...matches.map((x) => parseInt(x, 16))));
}
